var _excluded = ["leftElement", "rightElement", "size", "isViewMode", "isReadOnly", "isDisabled", "isLoading", "autoFocus", "maskProps", "containerRef", "placeholder", "viewModePlaceholder", "aria-required"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef, Input as ChakraInput } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useCallback, useState } from 'react';
import MaskedInput from 'react-text-mask';
import { Loader } from '../../../foundations/Loader';
import { themeSpaces } from '../../../theme/foundations';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { useFormControlContext } from '../../internal/FormControl';
import { InputGroup } from '../../internal/InputGroup';
import { InputLeftElement } from '../../internal/InputLeftElement';
import { InputRightElement } from '../../internal/InputRightElement';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TextField = forwardRef((_ref, _ref2) => {
  var {
    leftElement,
    rightElement,
    size = 'large',
    isViewMode,
    isReadOnly,
    isDisabled,
    isLoading,
    autoFocus,
    maskProps,
    containerRef,
    placeholder,
    viewModePlaceholder,
    'aria-required': ariaRequired = false
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var [leftElementWidth, setLeftElementWidth] = useState(null);
  var isFormContext = !isEmpty(useFormControlContext());
  var formFieldPlaceholder = viewModePlaceholder !== null && viewModePlaceholder !== void 0 ? viewModePlaceholder : placeholder;
  var standalonePlaceholder = isViewMode && viewModePlaceholder ? viewModePlaceholder : placeholder;
  var leftElementRef = useCallback(ref => {
    if (!ref) return;
    setLeftElementWidth(ref.clientWidth);
  }, // This needs to update when `isLoading` changes in order to update the padding.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isLoading]);
  var [rightElementWidth, setRightElementWidth] = useState(null);
  var rightElementRef = useCallback(ref => {
    if (!ref) return;
    setRightElementWidth(ref.clientWidth);
  }, // This needs to update when `isLoading` changes in order to update the padding.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isLoading]);
  var isEnabled = !isReadOnly && !isViewMode && !isDisabled;

  var inputMaskProps = _objectSpread({
    as: MaskedInput,
    guide: false,
    ref: textMaskClass => {
      if (_ref2) {
        if (typeof _ref2 === 'function') {
          _ref2(textMaskClass === null || textMaskClass === void 0 ? void 0 : textMaskClass.inputElement);
        } else if (typeof _ref2 === 'object') {
          _ref2.current = textMaskClass === null || textMaskClass === void 0 ? void 0 : textMaskClass.inputElement;
        }
      }
    }
  }, maskProps);

  var sharedProps = _objectSpread(_objectSpread({
    ref: _ref2,
    'data-component': 'TextField',
    autoFocus: autoFocus && isEnabled,
    'data-view-mode': isViewMode || null,
    'data-loading': isLoading || undefined,
    isDisabled,
    // We need to mark the input as `readOnly` when it's in view mode for accessibility reasons.
    isReadOnly: isReadOnly || isLoading || isViewMode,
    className: size,
    placeholder: isFormContext ? formFieldPlaceholder : standalonePlaceholder
  }, otherProps), {}, {
    paddingLeft: leftElementWidth ? "".concat(leftElementWidth, "px") : 's',
    paddingRight: rightElementWidth ? "calc(".concat(rightElementWidth, "px + ").concat(themeSpaces.m, ")") : 'none',
    tabIndex: isEnabled ? 0 : -1,
    isRequired: ariaRequired
  });

  var props = maskProps ? _objectSpread(_objectSpread({}, sharedProps), inputMaskProps) : sharedProps;
  var styles = useMultiStyleConfig('Input', {
    size
  });
  return /*#__PURE__*/_jsxs(InputGroup, {
    alignItems: "center",
    ref: containerRef,
    children: [!isViewMode && leftElement && /*#__PURE__*/_jsx(InputLeftElement, {
      ref: leftElementRef,
      sx: styles['leftElement'],
      children: leftElement
    }), /*#__PURE__*/_jsx(ChakraInput, _objectSpread({}, props)), (isLoading || rightElement) && /*#__PURE__*/_jsx(InputRightElement, {
      ref: rightElementRef,
      sx: styles['rightElement'],
      onClick: isLoading ? undefined : otherProps.onClick,
      children: isLoading ? /*#__PURE__*/_jsx(Loader, {}) : !isViewMode && rightElement
    })]
  });
});
TextField.displayName = 'TextField';
//# sourceMappingURL=TextField.js.map